module.exports = __webpack_public_path__ + "img/card.6153fe49.png";